import { downloadPartnersTablePdf } from '../api/downloadPartnersTablePdf';
import { downloadPartnersTableXlsx } from '../api/downloadPartnersTableXlsx';

type Formats = {
  pdf: boolean;
  excel: boolean;
};

type DownloadPartnersTableProps = {
  fileName: string;
  societyId: string;
  categoryId?: string;
  formats: Formats;
};

export const downloadPartnersTable = async ({
  fileName,
  societyId,
  categoryId,
  formats,
}: DownloadPartnersTableProps) => {
  if (formats?.excel) {
    await downloadPartnersTableXlsx({ fileName, societyId, categoryId });
  }
  if (formats?.pdf) {
    await downloadPartnersTablePdf({ fileName, societyId, categoryId });
  }
};
